module.exports = "<div> Um footer indiferente </div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/footer/templates/footer.template.html
// module id = 177
// module chunks = 0